var __jsx = React.createElement;
import React from 'react';
import { useTranslation } from "@i18n";
import { useCarCompareContext } from "@/_MiniApps/CarCompare/CarCompare";
import { CDN_LINK } from "@globalConfig";
import { twMerge } from "tailwind-merge";
import useHelpers from "@hooks/useHelpers";
var BlueSnackBar = function BlueSnackBar(_ref) {
  var _bigData$cars, _bigData$cars2;
  var _ref$containerClassNa = _ref.containerClassName,
    containerClassName = _ref$containerClassNa === void 0 ? "" : _ref$containerClassNa,
    _ref$postsLength = _ref.postsLength,
    postsLength = _ref$postsLength === void 0 ? null : _ref$postsLength,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading;
  var _useTranslation = useTranslation(["web_common"]),
    t = _useTranslation.t;
  var _useCarCompareContext = useCarCompareContext(),
    bigData = _useCarCompareContext.bigData,
    removeCar = _useCarCompareContext.removeCar,
    hasCarsToCompare = _useCarCompareContext.hasCarsToCompare;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl,
    navigateTo = _useHelpers.navigateTo;
  if ((bigData === null || bigData === void 0 ? void 0 : bigData.maxCars) == (bigData === null || bigData === void 0 ? void 0 : (_bigData$cars = bigData.cars) === null || _bigData$cars === void 0 ? void 0 : _bigData$cars.length) || !hasCarsToCompare()) return null;
  return /*#__PURE__*/React.createElement("div", {
    id: "posts-compare-snackbar",
    className: ["flex items-center justify-start p-3 gap-6 fixed z-[99999] w-[90%] md:w-[500px] h-[64px] flex-shrink-0 rounded-[4px] bg-[#3C56D4] shadow-[0px_8px_12px_0px_rgba(0,0,0,0.15)] bottom-[32px] right-[5%] md:ar:right-[calc(145px+50%-250px)] md:en:left-[calc(145px+50%-250px)]", twMerge(containerClassName)].join(" ")
  }, bigData === null || bigData === void 0 ? void 0 : (_bigData$cars2 = bigData.cars) === null || _bigData$cars2 === void 0 ? void 0 : _bigData$cars2.map(function (car, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index + "BlueSnackBar",
      id: "posts-compare-snackbar-car-".concat(car.id),
      onClick: function onClick() {
        removeCar(parseInt(car.id, 10));
      },
      className: "cursor-pointer border-solid w-[64px] h-[40px] rounded-[1.6px] border-[0.4px] border-[#E1E8F2] relative"
    }, /*#__PURE__*/React.createElement("img", {
      onClick: function onClick() {
        removeCar(parseInt(car.id, 10));
      },
      className: "hasEvents absolute ar:left-[-8px] en:right-[-8px] top-[-8px] z-[2]",
      width: "16px",
      height: "16px",
      src: CDN_LINK + "/assets/images/closeCompare.svg",
      alt: "remove car"
    }), /*#__PURE__*/React.createElement("img", {
      className: "object-cover w-full h-full absolute left-0 top-0 z-[1]",
      src: (car === null || car === void 0 ? void 0 : car.image_url) || (car === null || car === void 0 ? void 0 : car.img_url),
      alt: car === null || car === void 0 ? void 0 : car.title
    }));
  }), /*#__PURE__*/React.createElement("span", {
    className: "w-[1px] h-[32px] bg-[#E1E8F2]"
  }), (postsLength > 1 || loading) && /*#__PURE__*/React.createElement("span", {
    className: "text-white text-sm font-semibold leading-[16px] md:text-base md:leading-[24px]"
  }, t(" رائع 🎉 ! الآن قم باختيار أي سيارة أخرى ", {
    ns: "web_sell_trade"
  })), (postsLength === 1 || postsLength === 0) && !loading && /*#__PURE__*/React.createElement("button", {
    id: "posts-compare-snackbar-cta",
    onClick: function onClick() {
      return navigateTo("/filters");
    }
    // href={createUrl("/filters")}
    ,
    className: "cursor-pointer border-none bg-transparent flex items-center ar:mr-auto en:ml-auto w-1/2 justify-end"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-white text-sm font-bold leading-[16px] md:text-base md:leading-[24px]"
  }, t("اختر أي سيارة أخرى", {
    ns: "web_sell_trade"
  })), /*#__PURE__*/React.createElement("img", {
    className: "ar:rotate-180",
    width: "24",
    height: "24",
    src: CDN_LINK + "/assets/images/whtBck.svg",
    alt: "arrow"
  })));
};
export default BlueSnackBar;